import { render, staticRenderFns } from "./ResumeQuote.vue?vue&type=template&id=f7dc1efc&scoped=true"
import script from "./ResumeQuote.vue?vue&type=script&lang=js"
export * from "./ResumeQuote.vue?vue&type=script&lang=js"
import style0 from "./ResumeQuote.vue?vue&type=style&index=0&id=f7dc1efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7dc1efc",
  null
  
)

export default component.exports